import { useQuery } from "@tanstack/react-query";

import { getPricesOptions } from "../../generated/client/octalog-service/@tanstack/react-query.gen";

export const useGetPrices = () => {
  return useQuery({
    ...getPricesOptions(),
  });
};
